const COMMANDE_ACTION_PROFILE_KEYWORDS = [
  "intendance",
  "administration",
  "mairie",
  "direction",
  "gestionnaire",
  "agent comptable",
  "fin & adm",
  "collectivite",
];

export default {
  methods: {
    hasFieldValue(value) {
      if (typeof value === "string") {
        return value.trim().length > 0;
      }

      return ![undefined, null, ""].includes(value);
    },
    isFieldEmpty(value) {
      if (typeof value === "string") {
        return value.trim().length === 0;
      }

      return [undefined, null, ""].includes(value);
    },
    isEmailValid(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test((email || "").trim());
    },
    normalizeInputValue(value) {
      if (value === undefined || value === null) {
        return "";
      }

      return String(value).trim();
    },
    normalizeRecognitionValue(value) {
      return this.normalizeInputValue(value);
    },
    normalizeProfileSignal(value) {
      return this.normalizeInputValue(value)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    isCommandeActionProfileFromSignals(...signals) {
      const normalizedSignals = signals
        .map((signal) => this.normalizeProfileSignal(signal))
        .filter(Boolean);

      return normalizedSignals.some((signal) => (
        COMMANDE_ACTION_PROFILE_KEYWORDS.some((keyword) => signal.includes(keyword))
      ));
    },
    normalizeEtablissement(item = {}) {
      const infos = item.infos || item;

      return {
        id: item.id || infos.id || null,
        nom: infos.nom || infos.libelle || item.nom || item.libelle || "",
        libelle: infos.libelle || infos.nom || item.libelle || item.nom || "",
        niveau: infos.niveau || item.niveau || "",
        type: infos.type || item.type || "",
        adresse: infos.adresse || item.adresse || "",
        code_postal: infos.code_postal || item.code_postal || "",
        ville: infos.ville || item.ville || "",
        pays: infos.pays || item.pays || "",
        uai: infos.uai || item.uai || "",
        siren_siret: infos.siren_siret || item.siren_siret || "",
        libelle_nature: infos.libelle_nature || item.libelle_nature || "",
        statut_public_prive: infos.statut_public_prive || item.statut_public_prive || "",
      };
    },
    deduceCategoryFromFonction(fonction) {
      if (!fonction) return "";
      const lower = fonction.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      if (
        lower.includes("mairie")
        || lower.includes("region")
        || lower.includes("collectivite")
        || lower.includes("administratif (")
      ) {
        return "Collectivite";
      }
      if (
        lower.includes("comptable")
        || lower.includes("gestionnaire")
        || lower.includes("secretaire")
        || lower.includes("intendance")
        || lower.includes("fin & adm")
      ) {
        return "Fin & Adm";
      }
      if (lower.includes("chef") || lower.includes("directeur") || lower.includes("direction")) {
        return "Direction";
      }
      if (lower.includes("documentaliste") || lower.includes("cdi")) {
        return "CDI";
      }
      if (lower.includes("enseignant") || lower.includes("prof") || lower.includes("pedagogique")) {
        return "Pedagogique";
      }
      return "Autres";
    },
    extractResults(payload) {
      if (Array.isArray(payload?.results)) {
        return payload.results;
      }

      if (Array.isArray(payload)) {
        return payload;
      }

      return [];
    },
    getEtablissementSiretValue(etablissement = null) {
      const safeEtablissement = etablissement && typeof etablissement === "object"
        ? etablissement
        : {};

      return this.normalizeInputValue(safeEtablissement.siren_siret);
    },
    canOverrideSiretWithSelectedEtablissement(currentFacturationSiret, previousSelectedSiret) {
      const normalizedCurrentSiret = this.normalizeInputValue(currentFacturationSiret);
      const normalizedPreviousSelectedSiret = this.normalizeInputValue(previousSelectedSiret);

      return this.isFieldEmpty(normalizedCurrentSiret)
        || (!this.isFieldEmpty(normalizedPreviousSelectedSiret)
          && normalizedCurrentSiret === normalizedPreviousSelectedSiret);
    },
  },
};
